import React, { useState,useContext } from "react";
import SideBarStyle from "./SideBarStyle.module.css";
import { Link, useNavigate } from "react-router-dom";
//material ui
import Box from "@mui/material/Box";
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditIcon from '@mui/icons-material/Edit';
import CategoryIcon from '@mui/icons-material/Category';
//img
import profile from "../../assets/profile.jfif";
//import context
import {AuthContext} from '../../context/AuthContextProvider'
const SideBar = () => {
  const userName=useContext(AuthContext)
  //use state
  const [className, setClassName] = useState({
    hambergerOne: "hamberger1",
    hambergerTwo: "hamberger2",
    hambergerThree: "hamberger3",
  });
  const [Container, setContainer] = useState("allCotainer");

  //functions

  const closeOpen = () => {
    console.log("test");
    if (className.hambergerOne === "hamberger1") {
      setContainer("allContainerOpen");
      setClassName({
        hambergerOne: "hambergerOpen1",
        hambergerTwo: "hambergerOpen2",
        hambergerThree: "hambergerOpen3",
      });
    } else {
      setContainer("allCotainer");
      setClassName({
        hambergerOne: "hamberger1",
        hambergerTwo: "hamberger2",
        hambergerThree: "hamberger3",
      });
    }
  };
  const Navigate = useNavigate();
  return (
    <>
      <div onClick={closeOpen} className={SideBarStyle.hambergerContainer}>
        <span className={SideBarStyle[className.hambergerOne]}></span>
        <span className={SideBarStyle[className.hambergerTwo]}></span>
        <span className={SideBarStyle[className.hambergerThree]}></span>
      </div>
      <div className={SideBarStyle[Container]}>
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
          }}
        >
          <div className={SideBarStyle.TopSeaction}>
            <div className={SideBarStyle.imgContainer}>
              <img style={{ width: "100%" }} alt="top" src={profile} />
            </div>
            <h3 className={SideBarStyle.userName}>{userName.studentData.fullName}</h3>
          </div>
          <div className={SideBarStyle.downSection}>
            <ul className={SideBarStyle.ul}>
              <li
                onClick={() => {
                  Navigate("dashBoard");
                }}
              >
                <input
                  className={SideBarStyle.inputs}
                  type="radio"
                  id="d0"
                  name="r"
                />
                <label for="d0">
                  <DashboardIcon /><span className={SideBarStyle.spans}>داشبورد</span>
                </label>
              </li>
              <li className={SideBarStyle.cources}>
                <input
                  className={SideBarStyle.inputs}
                  type="radio"
                  id="d1"
                  name="r"
                />
                <label for="d1">
                 <CategoryIcon/> <span  className={SideBarStyle.spans}> دوره‌ها</span>
                </label>
                <div className={SideBarStyle.Links}>
                  <Link to="myCources"> <CategoryIcon/><span  className={SideBarStyle.spans}>دوره‌های من</span></Link>
                  <Link to="allCources"><CategoryIcon/><span  className={SideBarStyle.spans}>تمام‌دوره‌ها</span> </Link>
                </div>
              </li>
              <li>
                <input
                  onClick={() => {
                    Navigate("editProfile");
                  }}
                  className={SideBarStyle.inputs}
                  type="radio"
                  id="d2"
                  name="r"
                />
                <label htmlFor="d2">
                 <EditIcon/> <span  className={SideBarStyle.spans}>تغییر‌پروفایل</span>
                </label>
              </li>
            </ul>
          </div>
        </Box>
      </div>
    </>
  );
};

export default SideBar;
